export const environment = {
    environmentType: 'plusradiology',
    appVersion: require("../../package.json").version, //Fetching vesion of application.

    production: true,
    endPoint: 'https://plusradiology-test.ifourtechlab.com'
};
